import React, { useMemo } from 'react';
import { callApi } from '../utils/api';
import { FlowEnum } from '../openapi/types/FlowEnum';

const PATH: Record<FlowEnum, any> = {
  INITIAL_IMPORT: '/initial_docs/',
  DTM: '/dtm_docs/',
  GP: '/docs/',
  CHECK: '/docs/',
  DMVS_GAD_CHECK: '/docs/',
  DMVS_DTI: '/dmvs_dti_docs/',
  DMVS_GAD: '/dmvs_gad_docs/',
  CEPRO_IMPORT: '/cepro_docs/',
  BB_IMPORT: '/bb_docs/',
  DTM_KAD: '/dtm_kad_docs/',
  CROSS_OWNER: '/cross_owner_docs/',
  CROSS_WORKER: '/cross_worker_docs/',
  SVU_OWNER: '/svu_owner_docs/',
  SVU_WORKER: '/svu_worker_docs/',
  SVU_CROSS_OWNER: '/svu_cross_owner_docs/',
  SVU_CROSS_WORKER: '/svu_cross_worker_docs/',
  GP_BRNO: '/brno_docs/',
};

export function useDownloadLink(url: string, flow?: FlowEnum | null | '', action = 'download') {
  return useMemo(() => createDownloadLink(url, flow, action), [url, flow, action]);
}

/**
 *
 * @param url
 * @param docType = zmena default /docs/ - za PATH
 * @param action = zmena default /download/
 * @param downloadUrlParams = doplnujici GET parametry download URL
 * @params onError = funkce vyvolana v pripade chyby stahovani, nrebo neexistence souboru
 */
export function createDownloadLink(
  url: string,
  flow?: FlowEnum | null | '',
  action = 'download',
  downloadUrlParams = '',
  onShowError?: (visible: boolean) => void,
) {
  const downloadUrl = flow ? url?.replace('/docs/', PATH[flow]) : url;
  return {
    href: `${downloadUrl}${action}/`,
    onClick: async (event: React.SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onShowError?.(false);
      try {
        const tokenResponse = await callApi<{ token: string }>(
          `${downloadUrl}create_token_for_${action}/`,
          'POST',
        );
        if (!tokenResponse.ok || !tokenResponse.data) {
          onShowError?.(true);
          throw new Error('Cannot acquire token');
        }

        window.location.href = `${downloadUrl}${action}/?token=${tokenResponse.data.token}${downloadUrlParams}`;
      } catch (error) {
        console.error('Error downloading file', error);
      }
    },
  };
}
